import type Phaser from 'phaser';

/** Continuous ribbons keep the gust readable after its leading rings leave the screen. */
export function drawHalloweenGustStream(wind: Phaser.GameObjects.Graphics, x: number, y: number,
  age: number, fade: number): void {
  wind.fillStyle(0xe4fff0, 0.12 * fade);
  wind.fillTriangle(x - 28, y, x + 28, y, x - 520, 1320);
  wind.fillTriangle(x + 28, y, x - 520, 1320, x + 520, 1320);
  for (let lane = 0; lane < 9; lane++) {
    const side = (lane - 4) / 4;
    const points = Array.from({length:25}, (_, i) => {
      const p=i/24;
      return {x:x+side*(25+p*510)+Math.sin(p*9-age/180+lane)*18*p,
        y:y+p*(1320-y)};
    });
    wind.lineStyle(11, 0xb6e4d8, 0.24 * fade).strokePoints(points, false);
    wind.lineStyle(4, 0xfff9e6, (0.5+lane%2*0.2) * fade).strokePoints(points, false);
  }
  for (let i=0;i<10;i++) {
    const p=((age+i*137)%1350)/1350;
    const px=x+Math.sin(i*2.4+p*2)*p*430, py=y+p*(1320-y);
    wind.lineStyle(5,0xf7ffed,Math.sin(p*Math.PI)*0.9*fade);
    wind.beginPath();
    for(let j=0;j<20;j++) {
      const a=j/19*Math.PI*1.65, r=5+j*0.7;
      if(!j)wind.moveTo(px+Math.cos(a)*r,py+Math.sin(a)*r*0.55);
      else wind.lineTo(px+Math.cos(a)*r,py+Math.sin(a)*r*0.55);
    }
    wind.strokePath();
    wind.fillStyle(i%2?0xdbaa5a:0xa3bf77,Math.sin(p*Math.PI)*0.8*fade);
    wind.fillEllipse(px+20,py+12,7+p*4,13+p*5);
  }
}
